import Image from "next/image";
import React from "react";
import Pupuk from "@/assets/Images/pupuk.png";
import Tanam from "@/assets/Images/tanam.png";
import Sintan from "@/assets/Images/sintan.png";
import { useGetSupportApp } from "@/components/parts/admin/website-management/support-apps/api";
import Link from "next/link";
import { cn } from "@/lib/utils";

const IconMap = {
  SIMPUPUK: Pupuk,
  SIMTANAMAN: Tanam,
  ALSINTAN: Sintan,
};

const ColorMap = {
  SIMPUPUK: "bg-[#FDF5DE]",
  SIMTANAMAN: "bg-[#E7F8E3]",
  ALSINTAN: "bg-[#E4FBF8]",
};

const AppSection = () => {
  const { data } = useGetSupportApp();
  const detail = data?.data.items;
  return (
    <div className=" bg-[#DDE6D5] py-14">
      <div className="flex flex-col gap-4 container mx-auto ">
        <div className="flex flex-col gap-2 items-center">
          <div className="text-2xl md:text-3xl font-semibold">
            Aplikasi Pendukung
          </div>
          <div className="text-[#5A5A5A] text-sm md:text-base text-center">
            Kami menyediakan beragam aplikasi untuk membantu kegiatan pertanian
            di lapangan. Berikut adalah sistem informasi yang dapat diakses oleh
            masyarakat.
          </div>
        </div>
        {/*  */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {detail?.map((item, i) => (
            <Link
              key={i}
              href={item.link}
              className={cn(
                "p-4 h-[260px]  shadow-md rounded-xl flex flex-col gap-1 justify-center items-center",
                (ColorMap as any)[item.name]
              )}
            >
              <div className="h-[120px]">
                <Image
                  alt="icon"
                  height={600}
                  width={600}
                  src={(IconMap as any)[item.name]}
                  className="h-full object-contain w-fit"
                />
              </div>
              <div className="font-semibold text-lg">{item.name}</div>
              <div className="text-center">{item.description}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AppSection;
